// @ts-nocheck

import * as S from './CashBackEvents.styles'
import { EventCard } from '../../../EventCard/EventCard'
import { useSelector } from 'react-redux'
import { ReduxState } from '../../../../../redux/rootReducer'
import { Paragraph } from 'applaus-ui-kit'
import { useWindowSize } from '../../../../../hooks/useWindowSize'
import { useRef } from 'react'
import { isListableEvent } from '../../../../../utils/isListableEvent'

export const CashBackEvents = () => {
  const { events } = useSelector((state: ReduxState) => state.ContentsReducer)
  const { isDesktop } = useWindowSize()

  const scrollRef = useRef<HTMLDivElement>(null)

  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 200
    }
  }

  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= 200
    }
  }

  const listableEvents = events?.items?.filter(isListableEvent) ?? []

  return (
    <S.Container>
      <S.EventWrapper>
        <Paragraph variant="large" type="bold" className="title">
          Eventos
        </Paragraph>

        {isDesktop ? (
          <S.ScrollBox>
            <S.ButtonRight onClick={handleScrollRight}>
              <S.ArrowRight />
            </S.ButtonRight>
            <S.EventBox ref={scrollRef} id="card-cashback">
              {listableEvents.map((event, index) => (
                <EventCard key={event.id + index} {...event} />
              ))}
            </S.EventBox>
            <S.ButtonLeft onClick={handleScrollLeft}>
              <S.ArrowLeft />
            </S.ButtonLeft>
          </S.ScrollBox>
        ) : (
          <S.EventBox>
            {listableEvents.map((event, index) => (
              <EventCard key={event.id + index} {...event} />
            ))}
          </S.EventBox>
        )}
      </S.EventWrapper>
    </S.Container>
  )
}
